module.exports = __webpack_public_path__ + "static/media/title-background.c97ac880.jpg";